<template>
  <w-icon-wrapper
    :height="24"
    :width="22"
    icon-name="work-notification-icon"
    view-box="0 0 22 24"
  >
    <path
      id="_5_Notification_Icon"
      d="M22,18H20V10a8,8,0,0,0-6-7.738V2a2,2,0,0,0-4,0v.262A8,8,0,0,0,4,10v8H2a1,1,0,0,0,0,2H7.551a4.474,4.474,0,0,0,8.9,0H22a1,1,0,0,0,0-2ZM6,10a6,6,0,0,1,12,0v8H6Zm6,12a2.5,2.5,0,0,1-2.45-2h4.9A2.5,2.5,0,0,1,12,22Z"
      data-name="5 Notification_Icon"
      fill="currentColor"
      transform="translate(-1)"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconNotification' };
</script>
